import React, {useEffect, useState} from "react";
import close from "../Images/close-circle.svg";

const   Gallery = ({data}) => {

    const isMobile = window.matchMedia('(max-width: 700px)')
    const [showModal, setShowModal] = React.useState(false);
    const dataSort = [...data].sort((a, b) => {
        return Number.parseInt(b.col) - Number.parseInt(a.col)
    })
    const colsNumber = parseInt(dataSort[0].col)
    const [galleryMatriz, setGalleryMatriz] = useState([])
    const [mobileMatriz, setMobileMatriz] = useState([])
    const [indexModalImage, setIndexModalImage] = useState(0)
    const [modalImage, setModalImage] = useState(data[indexModalImage].image)

    useEffect(() => {
        let arrayColumnas = []
        for (let i = 1; i < colsNumber + 1; i++) {
            let columna = []
            for (let j = 0; j < dataSort.length; j++) {
                if (parseInt(dataSort[j].col) === i) {
                    columna.push(dataSort[j])
                }
            }
            arrayColumnas.push(columna)
        }
        setGalleryMatriz(arrayColumnas)

        let arrayMobile = []
        for (let i = 1; i < 3; i++) {
            let columna = []
            for (let j = 0; j < data.length; j++) {
                if (parseInt(data[j].mobile_col) === i) {
                    columna.push(data[j])
                }
            }
            arrayMobile.push(columna)
        }
        setMobileMatriz(arrayMobile)
    }, [data])

    useEffect(() => {
        setModalImage(data[indexModalImage].image)
    }, [indexModalImage])

    return (
        <div className={`p-10`}>
            <div className={`grid gap-2`}
                 style={{gridTemplateColumns: !isMobile.matches ? `repeat(${colsNumber}, minmax(0, 1fr))` : `repeat(2, minmax(0, 1fr))`}}>
                {
                    isMobile.matches ? mobileMatriz.map((item, index) => {
                        return (
                            <div className={`gap-2`}>
                                {item.map((image, index) => {
                                    return (
                                        <div className={`my-2 cursor-pointer`} style={{height: image.height}}>
                                            <img className="h-auto grayscale hover:filter-none max-w-full rounded-lg"
                                                 src={image.image} alt=""
                                                 onClick={() => setShowModal(true)}/>
                                        </div>
                                    )
                                })}
                            </div>
                        )
                    }) : galleryMatriz.map((item, index) => {
                        return (
                            <div className={`gap-2`}>
                                {item.map((image, index) => {
                                    return (
                                        <div className={`my-2 cursor-pointer overflow-hidden`}
                                             style={{height: image.height}}>
                                            <img
                                                className="h-auto grayscale hover:filter-none max-w-full rounded-lg hover:scale-125 duration-700"
                                                src={image.image} alt=""
                                                onClick={() => setShowModal(true)}/>
                                        </div>
                                    )
                                })}
                            </div>
                        )
                    })}
            </div>
            {showModal ? (
                <div
                    className="bg-[#00000080] justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-[999] outline-none focus:outline-none">
                    <div className="relative w-11/12 h-5/6 mt-1">
                        <div
                            className="relative border-0 relative flex flex-col w-full bg-transparent outline-none focus:outline-none h-full">
                            <div className="relative flex-auto py-8 md:py-8 md:px-12">
                                <div
                                    className={`h-96 w-full mt-1 md:w-3/6 justify-center md:m-auto bg-cover bg-no-repeat bg-center`}
                                    style={{backgroundImage: `url(${modalImage})`}}/>
                                <div className="h-fit w-full md:w-3/6 m-auto flex flex-row justify-between overflow-scroll md:overflow-hidden">
                                    {
                                        data ? data.map((item, index) => {
                                            return (
                                                <div
                                                    className={`shrink-0 w-[72px] h-[72px] md:h-[72px] md:w-[52px] my-5 mx-1 bg-cover bg-center md:grayscale cursor-pointer`}
                                                    style={{backgroundImage: `url(${item.image})`}}
                                                    onClick={() => setIndexModalImage(parseInt(index))}/>
                                            )
                                        }) : ''}
                                </div>
                            </div>
                            <div
                                className="absolute top-0 right-0 flex items-center z-30">
                                <button
                                    className="text-white background-transparent outline-none focus:outline-none mb-1 ease-linear"
                                    type="button"
                                    onClick={() => {
                                        setShowModal(false)
                                        setIndexModalImage(0)
                                    }}
                                >
                                    <img src={close} alt=""/>
                                </button>
                            </div>
                            <button type="button"
                                    className={`${indexModalImage === 0 ? 'hidden' : ''} absolute top-0 left-0 md:left-72 z-20 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none`}
                                    onClick={() => setIndexModalImage(indexModalImage - 1)}>
                                <span className="inline-flex items-center justify-center w-10 h-10">
                                    <svg aria-hidden="true" className="w-6 h-6 text-white dark:text-gray-800"
                                         fill="none" stroke="currentColor"
                                         viewBox="0 0 24 24"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path stroke-linecap="round"
                                              stroke-linejoin="round" stroke-width="2"
                                              d="M15 19l-7-7 7-7"/>
                                    </svg>
                                    <span className="sr-only">Previous</span>
                                </span>
                            </button>
                            <button type="button"
                                    className={`${indexModalImage === data.length - 1 ? 'hidden' : ''} absolute top-0 right-0 md:right-72 z-20 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none`}
                                    onClick={() => setIndexModalImage(indexModalImage + 1)}>
                                    <span className="inline-flex items-center justify-center w-10 h-10">
                                        <svg aria-hidden="true" className="w-6 h-6 text-white dark:text-gray-800"
                                             fill="none" stroke="currentColor"
                                             viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                            <path stroke-linecap="round"
                                                  stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                                        </svg>
                                        <span className="sr-only">Next</span>
                                    </span>
                            </button>
                        </div>
                    </div>
                </div>
            ) : null}
        </div>
    )
}

export default Gallery;